import { Select, SelectVariant } from '@focaldata/cin-ui-components'

export const colours = [
  {
    id: 'green',
    name: 'Green',
    value: '#DBEDDB'
  },
  {
    id: 'red',
    name: 'Red',
    value: '#FFD0CC'
  },
  {
    id: 'orange',
    name: 'Orange',
    value: '#FFD18A'
  },
  {
    id: 'grey',
    name: 'Grey',
    value: '#E3E2E0'
  }
]

const TextHighlighterColourSelect = ({
  onChange,
  style,
  optionValue
}: {
  onChange?: ({ value }: { value: string }) => void
  style?: React.CSSProperties
  optionValue?: string | number
}) => {
  return (
    <Select
      defaultOptionValue={colours[0].value}
      optionValue={optionValue}
      variant={SelectVariant.Outlined}
      style={style}
      options={colours.map((colour) => ({
        id: colour.id,
        name: colour.name,
        value: colour.value,
        preAdornment: (
          <div
            style={{
              height: '20px',
              width: '20px',
              backgroundColor: colour.value
            }}
          />
        )
      }))}
      onChange={(e) =>
        onChange?.({
          value: e.target.value
        })
      }
    />
  )
}

export default TextHighlighterColourSelect
